import ConfirmDialog from './ui/ConfirmDialog';

interface ConfirmModalProps {
  title: string;
  description: string;
  confirmLabel: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  danger?: boolean;
  /** Optional: locks both buttons while the action runs (passed to ConfirmDialog). */
  loading?: boolean;
}

/**
 * Kept for existing callers; renders `ui/ConfirmDialog` (T-27): alertdialog,
 * focus on "ביטול" first, Escape and the scrim cancel, enter motion, and a
 * bottom sheet below md.
 */
export default function ConfirmModal(props: ConfirmModalProps) {
  return <ConfirmDialog {...props} />;
}
